/** The product's name, wherever the portal, its sign-in page and the original My account say it. */
export const B2B_PORTAL_NAME = 'NoPressure.Work'

/** The staff console's name in its title, breadcrumbs and messages; the narrow sidebar says "Debug Console". */
export const B2B_STAFF_CONSOLE_NAME = `${B2B_PORTAL_NAME} Debug Console`

/** The most emails one B2B call takes (`B2B_MAX_EMAILS_PER_CALL` on the backend). */
export const B2B_MAX_EMAILS_PER_CALL = 50

/**
 * Query options for what shows a learner's progress: they practise in their assistant in another tab, so the page reads
 * again whenever it is back in front. `'always'`: `true` would skip data younger than the app's 5-minute stale time.
 */
export const REFETCH_WHEN_BACK_IN_FRONT = { refetchOnWindowFocus: 'always' } as const

/** Router state that opens a workflow's page with its edit form open: the workflows list's "Edit". */
export const OPEN_WORKFLOW_EDITING_STATE = { opensWorkflowEditing: true } as const

export function opensWorkflowEditing(state: unknown): boolean {
  return typeof state === 'object' && state !== null && 'opensWorkflowEditing' in state
}
